function userSearchBar () {
  return {
    replace: true,
    restrict: 'E',
    controller: 'UserSearchBarController',
    templateUrl: '/arts/directives/user-search-bar/user-search-bar-directive.html?$$REVISION$$',
    scope: {
      breadcrumbs: '=',
      onFilterChange: '&'
    }
  }
}

export { userSearchBar }
